<div class="form-login">
  <div class="text-center lgn-lg img">
    <br />

    <img
      src="assets/images/logo-white.png"
      class="center"
      alt="logo"
      width="200"
      title="logo"
    />
  </div>

  <div class="form-inner">
    @if (mailsent()) {
      <div class="alert alert-success">Mail sent to your email</div>
    }

    <form [formGroup]="forgotform" (ngSubmit)="submit()" novalidate>
      <div class="form-group ytb-lgn">
        <label for="userId" class="form-label fmlab-bg black left">
          User Id
          <span class="starclr">*</span>
        </label>

        <input
          type="text"
          id="userId"
          class="form-control hpl-enq-frm phonestyle"
          name="userId"
          formControlName="userId"
          autocomplete="username"
        />

        @if (getError(forgotform.get("userId"), "User Id"); as errorMsg) {
          <span class="err-msg text text-danger">
            {{ errorMsg }}
          </span>
        }
      </div>
    </form>

    <br />

    <div class="mt-10">
      <button
        type="button"
        class="btn btn-primary btn-block font13"
        (click)="submit()"
      >
        Submit
      </button>
    </div>

    <div class="mt-10">
      <button
        type="button"
        class="btn btn-default btn-block text-danger font600 font14 cursor text-underline"
        (click)="cancel('login')"
      >
        Cancel
      </button>
    </div>
  </div>
</div>
